import type {SlotGameStore} from "@gamzix/slot_core";

//@ts-ignore
class GambleComponent extends Game.src.component.GambleComponent {
    isFinishedBonusGame: boolean = false;

    onGameReady(){
        super.onGameReady();

        game.on(`BonusGameComponent.END_OUTRO_TRANSITION`, () => this.isFinishedBonusGame = true)
    }

    showAnimBtnGamble(){
        if(this.store.gameData.bonusGame.isStarted() && !this.isFinishedBonusGame) {
            //@ts-ignore
            this.isStartButtonVisible = false;
            return
        }
        super.showAnimBtnGamble();

        this.isFinishedBonusGame = false;
    }

    get store(): SlotGameStore{
        return <SlotGameStore>game.store
    }
}

//@ts-ignore
Game.src.component.GambleComponent = GambleComponent;
